const heroContent = {
    title: "مــــستر شريف اسامة 👋",
    description:
        "وحاصل على ليسانس لغة عربية ودراسات إسلامية - كلية دار العلوم جامعة القاهرة معلم مادة اللغة العربية للمرحلة الثانوية ",
    buttonText: "احجز الأن",
    imageAlt: "teacher image",
};

export default heroContent;
